import { render, staticRenderFns } from "./reminderForm.vue?vue&type=template&id=14f3e59e&"
import script from "./reminderForm.vue?vue&type=script&lang=js&"
export * from "./reminderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports